(ns machtfit.stepchall.date
  (:require [cljs-time.core :as time]
            [machtfit.format :as format]
            [re-frame.core :as rf]))

(defn stats-date [db]
  (let [stats-date' (-> db :ui :stepchall :stats-date)
        today (-> db :server-info :reference-today)]
    (cond
      (nil? stats-date') (format/date->keyword today)
      (< (format/keyword->date stats-date')
         (time/minus today (time/days 2))) :all
      :else stats-date')))

(defn entry-date [db]
  (-> db :ui :page :entry-date))

(rf/reg-sub ::entry-date
  (fn [db _]
    (entry-date db)))

(rf/reg-sub ::stats-date
  (fn [db _]
    (stats-date db)))
